"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_OPTIONS_TAB_PLACEHOLDER_TEXT = exports.DEFAULT_PLACEHOLDER_TEXT = exports.DEFAULT_PLACEHOLDER_TEXT_FOR_TRIGGER = exports.MAX_DROPDOWN_OPTIONS_HEIGHT = exports.EMPTY_ZAP_NAME = exports.STATIC_REPLACE_CHOICES = exports.ZT_ROUTE_PATH = exports.TEMPLATE_ROUTE_PATH = exports.INSTANT_ROUTE_PATH = exports.EDITOR_ROUTE_PATH = void 0;
exports.EDITOR_ROUTE_PATH = 'app/editor';
exports.INSTANT_ROUTE_PATH = 'app/instant';
exports.TEMPLATE_ROUTE_PATH = 'template/:szid';
exports.ZT_ROUTE_PATH = 'zap-template';
exports.STATIC_REPLACE_CHOICES = [
    {
        value: '///loading///',
    },
];
exports.EMPTY_ZAP_NAME = 'Name your zap';
exports.MAX_DROPDOWN_OPTIONS_HEIGHT = '340px';
exports.DEFAULT_PLACEHOLDER_TEXT_FOR_TRIGGER = `Enter text\u2026`;
exports.DEFAULT_PLACEHOLDER_TEXT = `Enter text or insert data\u2026`;
exports.DEFAULT_OPTIONS_TAB_PLACEHOLDER_TEXT = 'Choose value\u2026';
